

export const index = 2;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/(blank)/_layout.svelte.js')).default;
export const imports = ["_app/immutable/nodes/2.BZ7cWTTp.js","_app/immutable/chunks/scheduler.DHUbek42.js","_app/immutable/chunks/index.ClBRh6_e.js"];
export const stylesheets = ["_app/immutable/assets/app.tvSJHrfd.css"];
export const fonts = [];
